import React from 'react';
import styled from 'styled-components';

const TitleComponent = styled.div`
  font-family: ${props => props.theme.title.fontFamily};
  font-size: ${props => props.theme.title.fontSize};
  font-weight: ${props => props.theme.title.fontWeight};
  color: ${props => props.theme.title.color};
  margin-bottom: ${props => props.theme.title.marginBottom};
  justify-items: ${props => props.theme.title.justifyItems};

  @media (max-width: 480px) {
    font-size: ${props => props.theme.title.mobileFontSize}
  }
`;

TitleComponent.defaultProps = {
  theme: {
    title: {
      fontFamily: '"Maax Bold", "Arial", "sans-serif"',
      fontSize: '26px',
      fontWeight: 'normal',
      borderRadius: '0',
      marginbottom: '5px',
      color: '#000',
      center: true,
    }
  }
};

export default TitleComponent;

export const wrap = content => {
  return <TitleComponent>{content}</TitleComponent>;
};
